import { jsx } from "react/jsx-runtime";
import { getFeatureFlagState } from "../../../../utils/featureFlag.js";
import { Analytics } from "../../../Analytics/index.js";
import { CookieSettingsLinkClient } from "./client.js";
import { DEV_KEY_ENABLE_TRANSCEND_COOKIE_MONITORING } from "./constants.js";
async function CookieSettingsLink({
  entry
}) {
  var _a, _b;
  if (!entry) return null;
  let transcendCookieMonitoringEnabled = false;
  try {
    const featureFlagState = await getFeatureFlagState(
      DEV_KEY_ENABLE_TRANSCEND_COOKIE_MONITORING,
      process.env.APPNAME
    );
    transcendCookieMonitoringEnabled = featureFlagState.isEnabled;
  } catch (error) {
    console.error(
      `Error fetching feature toggle: ${DEV_KEY_ENABLE_TRANSCEND_COOKIE_MONITORING} from ConfigStack.`,
      error
    );
  }
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          identifier: "footer",
          trackedData: [
            (_b = (_a = entry == null ? void 0 : entry.active_state) == null ? void 0 : _a.active_state_link) == null ? void 0 : _b.title
          ],
          type: "ui"
        },
        trackType: "navigation"
      },
      children: /* @__PURE__ */ jsx(
        CookieSettingsLinkClient,
        {
          isTranscendConsentManagementEnabled: transcendCookieMonitoringEnabled,
          entry
        }
      )
    }
  );
}
export {
  CookieSettingsLink
};
